export default __webpack_public_path__ + "static/media/georgia_pantazi.204efd26.png";